import { range } from 'ramda';
import { IPaginationItem } from '../../types/pagination';

interface IPreparePaginationOptions {
  currentPage: number;
  totalPages: number;
}

// Общее количество кнопок
const PAGINATION_WIDTH = 7;
// Смещение последней кнопки относительно текущей позиции
const END_PAGE_OFFSET = 3;
// Смещение первой кнопки относительно последней
const START_PAGE_OFFSET = 5;

export function preparePagination(options: IPreparePaginationOptions): IPaginationItem[] {
  const { totalPages, currentPage } = options;

  if (totalPages <= 1) {
    return [];
  }

  // если общее количеств страниц не больше кол-ва элементов в блоке PAGINATION_WIDTH, выводим все
  if (totalPages <= PAGINATION_WIDTH) {
    return range(1, totalPages + 1).map(page => preparePage({ page, ...options }));
  }

  const pagination: IPaginationItem[] = [];

  const endPage = Math.min(Math.max(PAGINATION_WIDTH, currentPage + END_PAGE_OFFSET), totalPages);
  const startPage = endPage - START_PAGE_OFFSET;

  // В блоке пагинации всегда отображаем 1 страницу
  // [1] [startPage] [ ] [ ] [ ] [ ] [endPage]
  pagination.push(preparePage({ page: 1, ...options }));

  const mainRange = range(startPage, endPage + 1);

  mainRange.forEach((page, index) => {
    let title: string | undefined;

    if ((index === 0 && page > 2) || (index === mainRange.length - 1 && page < totalPages)) {
      title = '...';
    }
    pagination.push(preparePage({ page, title, ...options }));
  });

  return pagination;
}

interface IPreparePageOptions extends IPreparePaginationOptions {
  page: number;
  title?: string;
}

function preparePage({ page, currentPage, title }: IPreparePageOptions): IPaginationItem {
  return {
    page,
    disabled: page === currentPage,
    title: title || page.toString(),
  };
}
